module.exports = __webpack_public_path__ + "img/35.bd983f14.jpg";